import React from 'react';
import { css } from 'twin.macro';
import { VscLoading } from 'react-icons/vsc';

export const LoadingSpinner = ({ size = 24, color, height = 0 }) => {
    return (
        <div
            css={css`
                display: flex;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: ${height}px;
            `}
        >
            <VscLoading className="spin" fontSize={size} color={color} />
        </div>
    );
};

export const FullViewLoadingSpinner = ({ size = '70vh' }) => {
    return (
        <div
            css={css`
                height: ${size};
                position: relative;
            `}
        >
            <div
                css={css`
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 1;
                `}
            >
                <LoadingSpinner size={124} />
            </div>
        </div>
    );
};
